import React, { useState, useEffect } from 'react';
import { TextField, InputAdornment } from '@mui/material';
import useUnits from '@innovyze/stylovyze/lib/hooks/useUnits';
import usePrevious from '@innovyze/stylovyze/lib/hooks/usePrevious';
import { useFormikContext } from 'formik';
/**
 * this component is used to fix the issue where by storybook shows the incorrect
 * props in the props table
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const UnitFieldPropsInfo = (props) => React.createElement("div", null);
/**
 * The input field takes a default value and unit that are metric.
 * The value is converted internally to the configured unit system
 * in the global settings. The onChange event will return the
 * input value in metric and the unconverted value will be returned
 * as the originalValue
 */
export const UnitField = ({ unit, defaultValue, onChange, onBlur, min, max, step, ...otherProps }) => {
    const { getSystemUnit, getStandardisedValue, getSystemValueNoIntlFormat, system, } = useUnits();
    // store the value in the unit system
    const [internalValue, setInternvalValue] = useState(getSystemValueNoIntlFormat(`${defaultValue} ${unit}`));
    const internalUnit = getSystemUnit(unit);
    const lastUnit = usePrevious(internalUnit);
    const formikContext = useFormikContext();
    useEffect(() => {
        setInternvalValue(getSystemValueNoIntlFormat(`${defaultValue} ${unit}`));
    }, [defaultValue]);
    // convert the internal value to the current unit system when it updates
    useEffect(() => {
        if (!lastUnit)
            return;
        // need previously systems unit to convert measurement
        setInternvalValue(getSystemValueNoIntlFormat(`${internalValue} ${lastUnit}`));
    }, [system]);
    const adjustValueAsNeeded = (value) => {
        if (system === 'Imperial') {
            // mm -> in -> cm
            if (unit.toLowerCase() === 'mm')
                return (parseFloat(value) * 10).toString();
        }
        return value;
    };
    const onInternalChange = (e) => {
        const value = e.target.value;
        const convertedValue = adjustValueAsNeeded(getStandardisedValue(`${value} ${internalUnit}`));
        if (formikContext && otherProps.name)
            formikContext.setFieldValue(otherProps.name, convertedValue);
        setInternvalValue(value.toString());
        onChange?.({
            ...e,
            target: {
                ...e.target,
                value: convertedValue,
                originalValue: value,
            },
        });
    };
    const onInternalBlur = (e) => {
        const value = e.target.value;
        let convertedValue = value;
        if (system === 'Imperial') {
            // convert the measurement back to metric as this is the standard unit for storing
            convertedValue = getStandardisedValue(`${value} ${internalUnit}`);
            // Some imperial conversions dont come back correctely and need an adjustment
            if (convertedValue !== undefined) {
                // mm -> in -> cm
                if (unit.toLowerCase() === 'mm')
                    convertedValue = (parseFloat(convertedValue) * 10).toString();
            }
        }
        if (formikContext && otherProps.name)
            formikContext.setFieldValue(otherProps.name, convertedValue);
        setInternvalValue(value);
        onBlur?.({
            ...e,
            target: {
                ...e.target,
                value: convertedValue,
                originalValue: value,
            },
        });
    };
    const inputProps = {};
    if (min || min === 0) {
        inputProps.min = getSystemValueNoIntlFormat(`${min} ${unit}`);
    }
    if (max || max === 0) {
        inputProps.max = getSystemValueNoIntlFormat(`${max} ${unit}`);
    }
    if (step)
        inputProps.step = step;
    return (React.createElement(TextField, { ...otherProps, type: "number", value: internalValue, onChange: onInternalChange, onBlur: onInternalBlur, variant: otherProps.variant ?? 'outlined', InputProps: {
            ...otherProps.InputProps,
            endAdornment: (React.createElement(InputAdornment, { position: "end" }, internalUnit)),
        }, inputProps: inputProps }));
};
UnitField.defaultProps = {};
export default UnitField;
